import React from "react";
import PropertyListCard from "../../common/property-list-card";
import { PropertyListCardProps } from "./property-list-grid.interface";
// import PropertyListCardSkeleton from "../../../skeleton/card-skeleton";
import useProperty from "../../../hooks/context/useProperty";
import MobilePropertiesCard from "../../common/mobile-properties-card";
import { StatusObjectColorFilter } from "../../../utils/utils";

const PropertyListGrid = ({
  showMap,
  objProperty,
  isPlaceholderData,
  type
}: PropertyListCardProps) => {
  const { setHoveredProperty } = useProperty();
  const handlePropertyHover = (property: any) => {
    setHoveredProperty(property);
  };

  return (
    <>
      {/* {loading && !isPlaceholderData ? (
        <PropertyListCardSkeleton />
      ) : (
        <> */}
      {/* {!showMap && ( */}
        <MobilePropertiesCard
          isPlaceholderData={isPlaceholderData}
          item={objProperty}
          status={StatusObjectColorFilter(objProperty?.status)}
          loginType={type}
        />
      {/* )} */}
      <PropertyListCard
        loginType={type}
        id={objProperty.id}
        sfid={objProperty?.sfid}
        lat={objProperty?.latitude}
        lng={objProperty?.longitude}
        totalBath={objProperty?.baths || objProperty?.totalBath}
        sqft={objProperty?.sqft}
        bedRooms={objProperty?.beds || objProperty?.bedRooms}
        isPlaceholderData={isPlaceholderData}
        onHover={() => handlePropertyHover(objProperty)}
        onLeave={() => handlePropertyHover({})}
        imageUrl={objProperty.posterImage ?? "/images/default-property.jpg"}
        shape={"circle"}
        listedTitle={"Listed By"}
        defaultProfile={objProperty?.acquisitionAgent1?.smallBannerPhotoUrl}
        agentFirstName={objProperty?.acquisitionAgent1?.name?.split(" ")[0]}
        agentLastName={objProperty?.acquisitionAgent1?.name?.split(" ")[1]}
        salesInstruction={objProperty.salesInstruction}
        street={objProperty.street}
        location={objProperty.location}
        amount={objProperty.askingPrice}
        currencyCode="USD"
        locale="en-US"
        propertyId={objProperty.id}
        city={objProperty.city}
        state={objProperty.state}
        postalCode={objProperty.postalcode}
        favCount={objProperty?.favCount}
        status={StatusObjectColorFilter(objProperty?.status)}
        statusValue={objProperty.status}
        activatedAt={objProperty?.activatedAt}
        shareKey={objProperty?.shareKey}
        offerDueDateAndTime={objProperty?.offerDueDateAndTime}
        opportunitySfid={objProperty?.opportunitySfid}
        pubPropertySfid={objProperty?.pubPropertySfid}
        objPropertyDetails={objProperty}
      />
      {/* </>
      )} */}
    </>
  );
};

export default React.memo(PropertyListGrid);
